export enum SaveUserSettingsErrorCode {
  None = 0,
  StaleRecord = 1,
  UnknownError = 2,
}
